<template>
  <div class="w-full flex flex-col gap-4 text-left">
    <div class="w-full flex flex-wrap items-center justify-between gap-4">
      <div class="flex-grow min-w-[260px] sm:flex-grow-0 sm:w-2/5">
        <SearchInput
          width="100%"
          label="Buscar políticas"
          hide-details
          density="compact"
          data-testid="access-manager-search-input"
        />
      </div>
      <div class="flex-shrink-0">
        <FilledButton
          @click.stop="openShareModal()"
          text="Adicionar pessoa/grupo"
          width="220px"
          height="40px"
          :prepend-icon="mdiPlus"
          class="!bg-primary30"
          data-testid="add-person-group-button"
        />
      </div>
    </div>

    <AcessManagerTab />
    <SharePolicyModal />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { mdiPlus } from '@mdi/js'
import AcessManagerTab from './access.manager.tab.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import SearchInput from '@/components/designSystem/Inputs/SearchInput.vue'
import SharePolicyModal from '@/components/designSystem/modals/share.policy.modal.vue'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import { useHeaderStore } from '@/pinia-store/useHeaderStore'

const modalStore = useModalStore()
const headerStore = useHeaderStore()

onMounted(() => {
  headerStore.setTitle('Gerenciar Acesso', 'Gerencie pessoas e grupos com acesso ao sistema')
})

const openShareModal = () => {
  modalStore.toggleModal(EModals.SHARE_POLICY)
}
</script>
